<template>
  <b-card title="Unauthorized Domain(s)"
          sub-title="These Domain(s) are unauthorized for the users of this organization"
  >
    <AddUnauthorizedDomain></AddUnauthorizedDomain>
    <UnauthorizedDomainList></UnauthorizedDomainList>
  </b-card>
</template>

<script>
import AddUnauthorizedDomain from '@/xvisor/components/policyCenter/domain/AddUnauthorizedDomain.vue';
import UnauthorizedDomainList from '@/xvisor/components/policyCenter/domain/UnauthorizedDomainList.vue';

export default {
  components: {
    AddUnauthorizedDomain,
    UnauthorizedDomainList,
  },
};
</script>
